export function trimmedSpaces (para) {
  let res = ''
  if (para) {
    res = para.trim()
    return res
  }
  return para
}
